// Pure parser for DJI-style SRT cue text → telemetry object.
// No DOM, no Leaflet — testable in node via node:test.

const LATLON_RE =
  /\[\s*latitude\s*:\s*(-?\d+(?:\.\d+)?)\][^[]*\[\s*longitude\s*:\s*(-?\d+(?:\.\d+)?)\]/;
const ALT_RE =
  /\[\s*rel_alt\s*:\s*(-?\d+(?:\.\d+)?)\s+abs_alt\s*:\s*(-?\d+(?:\.\d+)?)\]/;
const YPR_RE =
  /\[\s*gb_yaw\s*:\s*(-?\d+(?:\.\d+)?)\s+gb_pitch\s*:\s*(-?\d+(?:\.\d+)?)\s+gb_roll\s*:\s*(-?\d+(?:\.\d+)?)\]/;

export function parseCue(text) {
  if (typeof text !== "string") return null;
  const ll = LATLON_RE.exec(text);
  if (!ll) return null;
  const lat = parseFloat(ll[1]);
  const lon = parseFloat(ll[2]);
  if (lat === 0 && lon === 0) return null;
  const out = { lat, lon };
  const alt = ALT_RE.exec(text);
  if (alt) {
    out.rel_alt = parseFloat(alt[1]);
    out.abs_alt = parseFloat(alt[2]);
  }
  const ypr = YPR_RE.exec(text);
  if (ypr) {
    out.yaw = parseFloat(ypr[1]);
    out.pitch = parseFloat(ypr[2]);
    out.roll = parseFloat(ypr[3]);
  }
  return out;
}
